export const greybackground = "bg-lightGrey rounded-button p-14 my-4 shadow-sm";
export const pagePadding = "px-[5%] md:px-[8%]";
export const memberStyle = "bg-oeaMain rounded-button mx-5 px-8 py-3 flex-none";
